'use client';

import { type EventNumber, getEventNumber } from '@svs/nova-poolbetting/schema/sport';
import { CouponRow } from '@svs/nova-poolbetting/ui/Coupon';
import { useSearchParams } from 'next/navigation';
import type { PropsWithChildren, ReactNode } from 'react';

type CouponRowContainerProps = PropsWithChildren & {
  eventNumber: EventNumber;
  className?: string;
};

/**
 * Container component for a coupon row.
 *
 * @param root0 Props for the coupon row container
 * @param root0.children Child components to render inside the row
 * @param root0.eventNumber Event number for the row
 * @param root0.className Optional class name for styling
 * @returns CouponRow component with the appropriate styling and children
 */
export function CouponRowContainer({ children, eventNumber, className }: CouponRowContainerProps): ReactNode {
  const searchParams = useSearchParams();

  const selectedEvent = Number.parseInt(searchParams.get('event') ?? '1', 10);
  let selectedEventNumber: number | undefined;
  try {
    selectedEventNumber = getEventNumber(selectedEvent);
  } catch {
    selectedEventNumber = 1;
  }

  const isSelected = selectedEventNumber === eventNumber;

  return (
    <CouponRow className={className} isSelected={isSelected}>
      {children}
    </CouponRow>
  );
}
